export default __webpack_public_path__ + "bafb73f339baf5ca640116cfc583ea95.svg";